<app-wizard
  *ngIf="wizardSteps"
  [showButtons]="false"
  [showStepper]="false"
  [steps]="wizardSteps"
  (finish)="onWizardFinish($event)"></app-wizard>
